import { ChartSettingsPopupModel, DefaultRiskManagementType } from "../models/chart-style/chart-settings-popup.model";
import { Timeframe } from "../models/enum/timeframe.enum";
import { TimeframeHelper } from "./timeframe-helpers";

export class TradeOrderPriceHelper {
    static getPixelOffset(timeframe: Timeframe): number {
        if (TimeframeHelper.timeframeIntraday(timeframe) || timeframe === Timeframe.Day) return 60;
        if (timeframe === Timeframe.Week || timeframe === Timeframe.Month) return 30;
        return 60;
    }

    static calcProfitTargetPrice(basePrice: number, topPixels: number, isLong: boolean, yAxis: any, timeframe: Timeframe, settings: ChartSettingsPopupModel, defaultPercentage?: number): number {
        if (settings?.useDefaultProfitTarget && settings?.defaultProfitTargetValue) {
            let price = basePrice;
            if (settings.defaultProfitTargetType === DefaultRiskManagementType.Dollars) {
                price = isLong ? price + settings.defaultProfitTargetValue : price - settings.defaultProfitTargetValue;
            } else if (settings.defaultProfitTargetType === DefaultRiskManagementType.Percentage) {
                price = isLong
                    ? price + price * (settings.defaultProfitTargetValue / 100)
                    : price - price * (settings.defaultProfitTargetValue / 100);
            }
            return TradeOrderPriceHelper.getRoundedPrice(price);
        }

        if (defaultPercentage) {
            const price = isLong
                ? basePrice + basePrice * (defaultPercentage / 100)
                : basePrice - basePrice * (defaultPercentage / 100);
            return TradeOrderPriceHelper.getRoundedPrice(price);
        }

        const offset = this.getPixelOffset(timeframe);
        return TradeOrderPriceHelper.getRoundedPrice(yAxis.toValue(isLong ? topPixels - offset : topPixels + offset));
    }

    static calcStopLossPrice(basePrice: number, topPixels: number, isLong: boolean, yAxis: any, timeframe: Timeframe, settings: ChartSettingsPopupModel, defaultPercentage?: number): number {
        if (settings?.useDefaultStopLoss && settings?.defaultStopLossValue) {
            let price = basePrice;
            if (settings.defaultStopLossType === DefaultRiskManagementType.Dollars) {
                price = isLong ? price - settings.defaultStopLossValue : price + settings.defaultStopLossValue;
            } else if (settings.defaultStopLossType === DefaultRiskManagementType.Percentage) {
                price = isLong
                    ? price - price * (settings.defaultStopLossValue / 100)
                    : price + price * (settings.defaultStopLossValue / 100);
            }
            return TradeOrderPriceHelper.getRoundedPrice(price);
        }

        if (defaultPercentage) {
            const price = isLong
                ? basePrice - basePrice * (defaultPercentage / 100)
                : basePrice + basePrice * (defaultPercentage / 100);
            return TradeOrderPriceHelper.getRoundedPrice(price);
        }

        const offset = this.getPixelOffset(timeframe);
        return TradeOrderPriceHelper.getRoundedPrice(yAxis.toValue(isLong ? topPixels + offset : topPixels - offset));
    }

    static getRoundedPrice(value: number): number {
        let price = value;
        if (price < 1) {
            price = parseFloat(price.toFixed(4));
        } else {
            price = parseFloat(price.toFixed(2));
        }
        return price;
    }
}
